/**
 * i18n namespace constants — use these instead of raw strings to avoid typos.
 *
 * Usage:
 *   import { NS } from '@/i18n/namespaces';
 *   const { t } = useTranslation(NS.DEVELOPER_PLAN);
 */
export const NS = {
  COMMON: 'common',
  DEVELOPER_REGISTRATION: 'developer-registration',
  DEVELOPER_PLAN: 'developer-plan',
  MANAGE_SUBSCRIPTION: 'manage-subscription',
  USER_SETTINGS: 'user-settings',
  ECGRID_PACKAGE_TEST: 'ecgrid-package-test',
} as const;

export type Namespace = (typeof NS)[keyof typeof NS];
